import { render, staticRenderFns } from "./CanPillBtn.vue?vue&type=template&id=baa1e6ec&"
import script from "./CanPillBtn.vue?vue&type=script&lang=js&"
export * from "./CanPillBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports